import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint } from '../../../util/theme';

const ModalWindow = styled.div`
  display: flex;
  justify-content: center;

  position: relative;

  height: ${props => props.height};
  width: ${props => (props.width ? props.width : '100%')};

  overflow-x: scroll;
  overflow-y: scroll;

  @media (min-width: ${getBreakpoint('md')}) {
    overflow-x: auto;
    overflow-y: auto;
  }
`;

export default ModalWindow;
